<div class="summary">
    <div
        class="left-panel"
        data-sentry="timeline-element-select"
        [ngClass]="{
            hidden: inHiddenNodeTree,
            'keyframes-enabled': elementFeatures.has(Feature.Animations)
        }"
        (click)="setSelections($event)">
        <div
            data-sentry="timeline-toggle-visibility"
            data-test-id="element-toggle-visibility"
            class="icon eye"
            (click)="toggleVisibility($event)">
            <ui-svg-icon
                [icon]="node.hidden ? 'visibility-hidden' : 'visibility-visible'"></ui-svg-icon>
        </div>
        <div
            class="name"
            [attr.data-test-id]="'te-' + node.name"
            [ngClass]="'group-level-' + groupLevel"
            #elementName>
            <div
                id="toggle-group"
                data-test-id="toggle-group"
                *ngIf="node | isGroupNode"
                class="icon toggle-group"
                [ngClass]="{ active: !collapsedGroup }"
                (click)="toggleGroup($event)">
                <ui-svg-icon [icon]="collapsedGroup ? 'folder' : 'folder-open'"></ui-svg-icon>
            </div>
            <ui-input
                #name
                ui-theme="tiny"
                [id]="'name-' + elementIndex"
                [discrete]="true"
                [dynamicWidth]="true"
                [value]="node.name"
                (cancel)="cancelSetName()"
                (mousedown)="startEditName($event)"
                (blur)="setName(name.value)"
                (dynamicWidthUpdated)="onDynamicWidthUpdate()"
                (submit)="submitName()"></ui-input>
            <div
                class="element-features"
                *ngIf="elementFeatures.size > 0">
                <div
                    class="icon feature"
                    *ngIf="elementFeatures.has(Feature.Feeds)">
                    <ui-svg-icon icon="feed"></ui-svg-icon>
                </div>
                <div
                    class="icon feature"
                    *ngIf="elementFeatures.has(Feature.Actions)">
                    <ui-svg-icon icon="de-action"></ui-svg-icon>
                </div>
            </div>
        </div>
        <ng-container *ngIf="node | isElementNode as element">
            <div
                id="toggle-animations-btn"
                data-test-id="toggle-animations-btn"
                class="icon toggle-animations"
                [ngClass]="{ active: expanded, hidden: element.locked || !element.animations.length }"
                (click)="toggleAnimations($event)">
                <ui-svg-icon icon="animation"></ui-svg-icon>
            </div>
        </ng-container>
        <div
            class="icon lock"
            data-sentry="timeline-element-unlock"
            *ngIf="node.locked"
            (click)="toggleLocked()">
            <ui-svg-icon icon="lock-closed"></ui-svg-icon>
        </div>
        <div
            class="icon menu"
            [ngClass]="{ active: selected && timeline.editor.workspace.contextMenuOpen }"
            *ngIf="!node.locked"
            (mousedown)="openContextMenu($event, true)">
            <ui-svg-icon icon="kebab"></ui-svg-icon>
        </div>
    </div>
    <div
        data-sentry="timeline-bar"
        class="right-canvas">
        <div class="canvas-wrapper">
            <canvas
                #elementCanvas
                class="element-canvas"></canvas>
        </div>
    </div>
</div>

<ng-container *ngIf="node | isElementNode as element">
    <div class="animations-expanded">
        <section-expand
            class="animations"
            #animationSection
            [scrollIntoView]="false"
            [expanded]="expanded"
            arrowPosition="calc(var(--left-panel-width) - 33px)"
            [arrowSize]="6"
            [showBackground]="true"
            [showShadow]="false"
            (animationStateChanged)="sectionStateChange($event)">
            <ng-container *ngFor="let animation of element.animations; trackBy: getAnimationId">
                <timeline-animation
                    #animation
                    [animation]="animation"
                    [element]="element"
                    [groupLevel]="groupLevel">
                </timeline-animation>
            </ng-container>
        </section-expand>
    </div>
</ng-container>
